import { z } from "zod";
/**
 * «Mensajes de seguimiento» (plan feature `reengagement`, Agente → Ajustes).
 *
 * The bounds the admin may choose from. The DB CHECKs the same ranges
 * (`20261015120000_add_reengagement`), so a hand-written UPDATE cannot schedule
 * a follow-up every minute either. Hours are local to the client and half-open:
 * `[sendFromHour, sendUntilHour)`, so `until = 24` means "until midnight".
 */
export const REENGAGEMENT_LIMITS = {
    minDelayMinutes: 15,
    /** Three days. On WABA anything past the 24h window is never sent anyway. */
    maxDelayMinutes: 4320,
    minMessages: 1,
    maxMessages: 5,
};
/** What a client starts from — the column defaults, mirrored for the CRM. */
export const REENGAGEMENT_DEFAULTS = {
    enabled: false,
    delayMinutes: 240,
    maxMessages: 2,
    sendFromHour: 9,
    sendUntilHour: 20,
};
const hourSchema = z.number().int().min(0).max(23);
/**
 * `PUT /crm/reengagement/settings` — any subset of the fields. Partial so each
 * control saves the moment it changes, strict so a typo is a 400 rather than a
 * silent no-op (the `updateNotificationSettingsSchema` shape). `from < until`
 * is checked here when both arrive together and by the service against the
 * stored value when only one does.
 */
export const updateReengagementSettingsSchema = z
    .object({
    enabled: z.boolean().optional(),
    delayMinutes: z
        .number()
        .int()
        .min(REENGAGEMENT_LIMITS.minDelayMinutes)
        .max(REENGAGEMENT_LIMITS.maxDelayMinutes)
        .optional(),
    maxMessages: z
        .number()
        .int()
        .min(REENGAGEMENT_LIMITS.minMessages)
        .max(REENGAGEMENT_LIMITS.maxMessages)
        .optional(),
    sendFromHour: hourSchema.optional(),
    sendUntilHour: z.number().int().min(1).max(24).optional(),
})
    .strict()
    .refine((v) => Object.keys(v).length > 0, "Indica al menos una opción")
    .refine((v) => v.sendFromHour === undefined ||
    v.sendUntilHour === undefined ||
    v.sendFromHour < v.sendUntilHour, "La hora de inicio debe ser anterior a la hora de fin");
//# sourceMappingURL=reengagement.js.map